module.exports = __webpack_public_path__ + "assets/img/lines.98f5e276.svg";